import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import BrandLoadingScreen from './BrandLoadingScreen';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <BrandLoadingScreen message="We are securing your dashboard access." />;
  }

  if (!user) {
    // Not logged in → redirect to login, but save current location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}